import { render, staticRenderFns } from "./Weijinci.vue?vue&type=template&id=2ea92edc&scoped=true&"
import script from "./Weijinci.vue?vue&type=script&lang=js&"
export * from "./Weijinci.vue?vue&type=script&lang=js&"
import style0 from "./Weijinci.vue?vue&type=style&index=0&id=2ea92edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea92edc",
  null
  
)

export default component.exports